// extracted by mini-css-extract-plugin
export default {"reactCode-input":"confirmation_reactCode-input__SXXV1"};